import type DefaultLocale from './locales/default';
import type { LiteralToPrimitiveDeep } from 'type-fest';

/**
 * Languages supported by the git-backed internationalization feature.
 * These should match the folders in `packages/hub/public/locales`.
 */
export const i18nLanguages = ['en', 'de', 'es', 'fr', 'it', 'ja', 'pt', 'zh'] as const;

export type I18nLanguage = (typeof i18nLanguages)[number];

export const i18nLanguageLabels = {
  de: {
    label: 'German',
    labelNative: 'Deutsch',
  },
  en: {
    label: 'English',
    labelNative: 'English',
  },
  es: {
    label: 'Spanish',
    labelNative: 'Español',
  },
  fr: {
    label: 'French',
    labelNative: 'Français',
  },
  it: {
    label: 'Italian',
    labelNative: 'Italiano',
  },
  ja: {
    label: 'Japanese',
    labelNative: '日本語',
  },
  pt: {
    label: 'Portuguese',
    labelNative: 'Português',
  },
  zh: {
    label: 'Chinese',
    labelNative: '中文',
  },
} as const;

i18nLanguageLabels satisfies Record<I18nLanguage, { label: string; labelNative: string }>;

/**
 * The shape of our i18n JSON locales.
 * This is derived from the English locale, which is our default language and guaranteed
 * to have all keys present.
 */
export type LocaleData = LiteralToPrimitiveDeep<typeof DefaultLocale>;
